<section class="content">
    <div class="card" style="padding: 25px">
        <div class="row">
            <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
                {{title}}
            </div>
        </div>
        <div class="container-fluid">
            <div class="row">
                <div class="row">
                    <div class="col-3">
                        <mat-label>From Date</mat-label>
                        <input type="date" [(ngModel)]="from_date" class="main-border-class" />
                    </div>
                    <div class="col-3">
                        <mat-label>To Date</mat-label>
                        <input type="date" [(ngModel)]="to_date" class="main-border-class" [min]="from_date" />
                    </div>
                    <div class="col-3">
                        <mat-label>Booth Code</mat-label>
                        <input type="text" [(ngModel)]="business_code"
                            style="border: 1px solid black; border-radius: 15px; text-indent: 10px; font-size: 20px; padding: 9px;">
                    </div>
                    <div class="col-2">
                        <button (click)="getClicked()"
                            style="font-size: 27px;margin-top: 20%;border-radius: 10px;background: blanchedalmond;"
                            [disabled]="to_date == null || from_date == null || business_code == null || business_code == ''">Get</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card" style="padding: 25px; margin-top: 2%;" *ngFor="let date of sale_dict | keyvalue; let data_index = index">
        <div class="row">
            <div class="col" style="font-size: 20px; font-weight: 500;">{{'Sale For Date : '}} <span style="color: steelblue;">{{date.key | date}}</span></div>
            <!-- <div class="col" style="font-size: 10px; font-weight: 500;">{{'Orderd On : '}} <span style="color: steelblue;">{{date.key | date: 'MMM d, y, h:mm:ss a'}}</span></div>
            <div class="col" style="font-size: 10px; font-weight: 500;">{{'Edited On : '}} <span style="color: steelblue;">{{date.key | date: 'MMM d, y, h:mm:ss a'}}</span></div> -->
            <div class="col">
                <button mat-raised-button style="float: right; color: white; background-color: steelblue;" (click)='ProductReportCalled(business_code, date.key, date.key)'> View Transaction</button>
            </div>
            <hr style="width:100%;text-align:left;margin-top:5px;margin-bottom: 0;">
        </div>

        <div class="row">
            <div class="col-8">
                <table style="font-size: 11px;">
                    <tr>
                        <th>Session</th>
                        <th *ngFor="let product of sale_dict[date.key]['sale'] | keyvalue" style="text-align: right;">{{product.key}}</th>
                    </tr>
                    <tr>
                        <td>Mor</td>
                        <td *ngFor="let mor_product of sale_dict[date.key]['sale'] | keyvalue" style="text-align: right;">{{sale_dict[date.key]['sale'][mor_product.key]['mor']['litre'] | number:'1.3'}}</td>
                    </tr>
                    <tr>
                        <td>Eve</td>
                        <td *ngFor="let eve_product of sale_dict[date.key]['sale'] | keyvalue" style="text-align: right;">{{sale_dict[date.key]['sale'][eve_product.key]['eve']['litre'] | number:'1.3'}}</td>
                    </tr>
                    <tr>
                        <td>Amount</td>
                        <td *ngFor="let tot_product of sale_dict[date.key]['sale'] | keyvalue" style="text-align: right;">{{(sale_dict[date.key]['sale'][tot_product.key]['eve']['cost'] + sale_dict[date.key]['sale'][tot_product.key]['mor']['cost']) | number:'1.2' }}</td>
                    </tr>
                </table>
            </div>
            <div class="col-1">
                <div class="row" id="vl">
                </div>
            </div>
            <div class="col-3">
                <div class="row" style="margin-left: -34%; margin-top: 5%;">
                    <div class="col" style="font-size: 12px; font-weight: 700; line-height: 1.5;">{{'Total Amount : '}} <span style="color: steelblue;">{{sale_dict[date.key]['total_amount'] | number:'1.2'}}</span></div>
                </div>

                <div class="row" style="margin-left: -34%; margin-top: 2%;">
                    <div class="col" style="font-size: 11px; font-weight: 700; line-height: 1.5;">{{'Morning Sale : '}}</div>
                </div>
                <div class="row" style="margin-left: -30%; margin-top: 1%;">
                    <div class="col" style="font-size: 10px; font-weight: 700; line-height: 1.5;">{{'Total Amount : '}} <span style="color: steelblue;">{{sale_dict[date.key]['mor_sale'] | number:'1.2'}}</span></div>
                </div>
                <div class="row" style="margin-left: -30%;  margin-top: 1%;">
                    <div class="col" style="font-size: 10px; font-weight: 700; line-height: 1.5;">{{'Orderd Via : '}} <span style="color: steelblue;">{{sale_dict[date.key]['mor_ordered_via']}}</span></div>
                </div>
                <div class="row" style="margin-left: -30%;  margin-top: 1%;">
                    <div class="col" style="font-size: 10px; font-weight: 700; line-height: 1.5;">{{'Ordered On : '}} <span style="color: steelblue;">{{sale_dict[date.key]['mor_order_time_created'] | date: 'M/d/yy, h:mm:ss a'}}</span></div>
                    <div class="col" style="font-size: 10px; font-weight: 700; line-height: 1.5;">{{'Edited On : '}} <span style="color: steelblue;">{{sale_dict[date.key]['mor_order_time_modified'] | date: 'M/d/yy, h:mm:ss a'}}</span></div>
                </div>


                <div class="row" style="margin-left: -34%; margin-top: 2%;">
                    <div class="col" style="font-size: 11px; font-weight: 700; line-height: 1.5;">{{'Evening Sale : '}}</div>
                </div>
                <div class="row" style="margin-left: -30%; margin-top: 1%;">
                    <div class="col" style="font-size: 10px; font-weight: 700; line-height: 1.5;">{{'Total Amount : '}} <span style="color: steelblue;">{{sale_dict[date.key]['eve_sale'] | number:'1.2'}}</span></div>
                </div>
                <div class="row" style="margin-left: -30%;  margin-top: 1%;">
                    <div class="col" style="font-size: 10px; font-weight: 700; line-height: 1.5;">{{'Orderd Via : '}} <span style="color: steelblue;">{{sale_dict[date.key]['eve_ordered_via']}}</span></div>
                </div>
                <div class="row" style="margin-left: -30%;  margin-top: 1%;">
                    <div class="col" style="font-size: 10px; font-weight: 700; line-height: 1.5;">{{'Ordered On : '}} <span style="color: steelblue;">{{sale_dict[date.key]['eve_order_time_created'] | date: 'M/d/yy, h:mm:ss a'}}</span></div>
                    <div class="col" style="font-size: 10px; font-weight: 700; line-height: 1.5;">{{'Edited On : '}} <span style="color: steelblue;">{{sale_dict[date.key]['eve_order_time_modified'] | date: 'M/d/yy, h:mm:ss a'}}</span></div>
                </div>

            </div>

        </div>

    </div>
</section>